<template>
<transition name="slide" appear>
    <div class="info-wrapper" v-if="visible">
        <div class="info-body">
            <div class="info-head">
                <div class="button-spacer"></div>
                <h1 v-if="this.$route.name !=='Explore'">{{ currentObject.name }} Gate</h1>
                <h1 v-else>{{currentObject.title}}</h1>
                <button class="close" @click="toggleVisibility">
                    <img src="/images/ui/ui_close.png" alt="Close Collection View">
                </button>
            </div>
            <p>{{ currentObject.description }}</p>
        </div>
    </div>
</transition>
</template>

<script>
import Gate3dMetadataList from '../mixins/gates-3d-metadata'
export default {
    name: "Gate3dMetadata",
    mixins: [
        Gate3dMetadataList
    ],
    props: {
        gateName: String,
    },
    data() {
        return {
            visible: true,
            currentObject: null,
        }
    },


    methods: {

        extractMetadata() {
            this.currentObject = this.gates3dMeta.find(gatesData => {
                return gatesData.name === this.gateName
            });
        },

        toggleVisibility() {
            this.visible = !this.visible
        },
    },

    created() {
        this.extractMetadata()
    },

}
</script>

<style scoped>
.info-wrapper {
    position: fixed;
    align-content: center;
    bottom: 0;
    right: 0;
    width: 18.45em;
    height: calc(100vh - 5.5em);
    max-width: 100vw;
    overflow-y: scroll;
    background-color: var(--modal-back);
    border-radius: .5em .5em 0 0;
}

.info-body {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.info-head {
    display: flex;
    align-items: center;
    margin: 0 .35em;
    justify-content: space-between;
}

.close {
    top: .35em;
    left: .35em;
    height: 50px;
    width: 50px;
    display: inline;
    font: inherit;
    background: none;
    color: inherit;
    border: none;
    cursor: pointer;
    outline: inherit;
    width: 57px;
    height: 57px;
    line-height: 1.15;
    padding: 0;
    pointer-events: auto;
}

.close img {
    padding: 0;
    margin: 0 auto;
    width: 45px;
    height: 45px;
    display: block;
}

h1 {
    font-size: 1.25em;
    line-height: 1.15;
    padding-left: .5em;
    margin: 1.2em 0 1em;
}

p {
    padding: 0 .5em 3.25em;
    margin: 0 0 1.5em;
}

.button-spacer {
    display: none;
}

.slide-enter-active,
.slide-leave-active {
    transition: transform 1s;
}

.slide-enter,
.slide-leave-to {
    transform: translateY(100%);
}

@media screen and (min-width: 660px) {
    .info-wrapper {
        max-height: 70vh;
        border-radius: .5em 0 0 0;
    }
    .button-spacer {
        display: block;
        min-width: 45px;
    }
    h1 {
        font-size: 1.5em;
        padding-left: 0;
    }
    p {
        padding: 0 1em 3.25em;
    }
}
</style>
